package gr.tech.site.components.states

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.styles.states.FaqAccordionStyle
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text

data class FaqItem(val question: String, val answer: String)

@Composable
fun FaqAccordion(
    items: List<FaqItem>,
    accordionId: String = "faq-accordion",
    baseModifier: Modifier = FaqAccordionStyle.toModifier()
) {
    Div(
        attrs = baseModifier
            .classNames("accordion")
            .id(accordionId)
            .toAttrs()
    ) {
        items.forEachIndexed { index, item ->
            val headingId = "$accordionId-heading-$index"
            val collapseId = "$accordionId-collapse-$index"

            Div(attrs = Modifier.classNames("accordion-item").toAttrs()) {
                H2(
                    attrs = Modifier
                        .classNames("accordion-header")
                        .id(headingId)
                        .toAttrs()
                ) {
                    Button(
                        attrs = Modifier
                            .classNames("accordion-button", "collapsed")
                            .attrsModifier {
                                attr("type", "button")
                                attr("data-bs-toggle", "collapse")
                                attr("data-bs-target", "#$collapseId")
                                attr("aria-expanded", "false")
                                attr("aria-controls", collapseId)
                            }
                            .toAttrs()
                    ) {
                        Text(item.question)
                    }
                }
                Div(
                    attrs = Modifier
                        .classNames("accordion-collapse", "collapse")
                        .id(collapseId)
                        .attrsModifier {
                            attr("aria-labelledby", headingId)
                            attr("data-bs-parent", "#$accordionId")
                        }
                        .toAttrs()
                ) {
                    Div(attrs = Modifier.classNames("accordion-body").toAttrs()) {
                        Text(item.answer)
                    }
                }
            }
        }
    }
}
